import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomNumberFormatPipe } from './custom-number-format/custom-number-format.pipe';



@NgModule({
  declarations: [CustomNumberFormatPipe],
  imports: [
    CommonModule
  ],
  exports: [CustomNumberFormatPipe]
})
export class PipesModule { }
